module.exports = __webpack_public_path__ + "name=img/src/assets/icons/ic_youtube_accent.svg?81d171585ad31ace927502c03e76bcd2";